import * as Sentry from '@sentry/browser';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, debounceTime, map, switchMap } from 'rxjs/operators';

import { PaymentStateInfo } from '@cashier/cashier-model';

import {
  fetchPaymentCurrentStateStart,
  fetchPaymentCurrentStateSuccess,
  fetchPaymentInfoFailure,
  fetchPaymentInfoStart,
  fetchPaymentInfoSuccess,
} from './paymentInformation.slice';

export const fetchPaymentInfoEpic = (action$: any, state$: any, { Api }) =>
  action$.pipe(
    ofType(fetchPaymentInfoStart.type),
    switchMap((action: { payload: string }) =>
      Api.fetchPaymentInfo(action.payload).pipe(
        map((data: PaymentStateInfo) => fetchPaymentInfoSuccess(data)),
        catchError((err) =>
          of(() => {
            Sentry.captureException(new Error('Sentry exception error:'), {
              extra: {
                response: err,
              },
            });

            return fetchPaymentInfoFailure(err);
          }),
        ),
      ),
    ),
  );

export const fetchPaymentInfo = (transactionId: string) => ({
  type: fetchPaymentInfoStart.type,
  payload: transactionId,
});

export const fetchPaymentCurrentStateEpic = (
  action$: any,
  state$: any,
  { Api },
) =>
  action$.pipe(
    ofType(fetchPaymentCurrentStateStart.type),
    debounceTime(1000),
    switchMap((action: { payload: string }) => {
      if (action.payload) {
        return Api.fetchPaymentInfo(action.payload).pipe(
          map((data: PaymentStateInfo) =>
            fetchPaymentCurrentStateSuccess(data),
          ),
        );
      }
    }),
  );

export const fetchPaymentCurrentState = (transactionId: string) => ({
  type: fetchPaymentCurrentStateStart.type,
  payload: transactionId,
});
